var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2857 0H2.7058C1.21295 0 0 1.22991 0 2.73973V35.2603C0 36.7701 1.21295 38 2.7058 38H35.2857C36.7786 38 38 36.7701 38 35.2603V2.73973C38 1.22991 36.7786 0 35.2857 0ZM11.4848 32.5714H5.85268V14.4366H11.4933V32.5714H11.4848ZM8.66875 11.9598C6.86205 11.9598 5.40312 10.4924 5.40312 8.6942C5.40312 6.89598 6.86205 5.42857 8.66875 5.42857C10.467 5.42857 11.9344 6.89598 11.9344 8.6942C11.9344 10.5009 10.4754 11.9598 8.66875 11.9598ZM32.5969 32.5714H26.9647V23.75C26.9647 21.6464 26.9223 18.9406 24.0384 18.9406C21.1036 18.9406 20.654 21.2308 20.654 23.5973V32.5714H15.0219V14.4366H20.425V16.9134H20.5013C21.2562 15.4884 23.0969 13.9871 25.8366 13.9871C31.5366 13.9871 32.5969 17.7446 32.5969 22.6304V32.5714Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.55523f62797ddb51e960322dd47e5636.svg";
export { ForwardRef as ReactComponent };